__turbopack_context__.v({
  "buySection": "index-module__Ji1dXq__buySection",
  "chargerLearnMoreModal": "index-module__Ji1dXq__chargerLearnMoreModal",
  "disclaimerButton": "index-module__Ji1dXq__disclaimerButton",
  "disclaimerButtonContainer": "index-module__Ji1dXq__disclaimerButtonContainer",
  "heightOpacityIn": "index-module__Ji1dXq__heightOpacityIn",
  "largePrompt": "index-module__Ji1dXq__largePrompt",
  "learnMoreButton": "index-module__Ji1dXq__learnMoreButton",
  "leftPanel": "index-module__Ji1dXq__leftPanel",
  "mobileCarouselSection": "index-module__Ji1dXq__mobileCarouselSection",
  "notServicableMessageContainer": "index-module__Ji1dXq__notServicableMessageContainer",
  "powerPlugSubsection": "index-module__Ji1dXq__powerPlugSubsection",
  "priceContentContainer": "index-module__Ji1dXq__priceContentContainer",
  "rightPanel": "index-module__Ji1dXq__rightPanel",
  "root": "index-module__Ji1dXq__root",
  "section": "index-module__Ji1dXq__section",
  "separator": "index-module__Ji1dXq__separator",
  "sizeInfoModal": "index-module__Ji1dXq__sizeInfoModal",
  "stickyPanel": "index-module__Ji1dXq__stickyPanel",
});
